import { Link } from "react-router-dom";

/**
 * ReplyDriven Logo Component
 * 
 * Usage:
 * - <Logo /> - Icon only (32x32)
 * - <Logo showText /> - Icon + "ReplyDriven" text
 * - <Logo size="sm" /> - Small icon (24x24)
 * - <Logo size="lg" /> - Large icon (48x48)
 */
const Logo = ({ 
  showText = false, 
  size = "md",
  linkTo = "/",
  className = ""
}) => {
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  const textSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  const logoContent = (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={`${sizes[size]} rounded-lg overflow-hidden`}>
        <img 
          src="/favicon.png" 
          alt="ReplyDriven" 
          className="w-full h-full object-cover"
        />
      </div>
      {showText && (
        <span className={`font-heading font-bold ${textSizes[size]}`}>
          ReplyDriven
        </span>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center gap-2 hover:opacity-90 transition-opacity">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;
